document.addEventListener("DOMContentLoaded", () => {

    let latestNewsSwipersDesktop = document.getElementsByClassName('latestnewslider-swiper-desktop');

    for (let i = 0; i < latestNewsSwipersDesktop.length; i++) {

        let swiperElementDesktop = latestNewsSwipersDesktop[i];

        let swiperDesktopID = '#' + swiperElementDesktop.id;

        const swiperDesktop = new Swiper(swiperDesktopID, {
            pagination: {
                el: swiperDesktopID + "-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: swiperDesktopID + "-next",
                prevEl: swiperDesktopID + "-prev",
            },
            direction: 'vertical',
            loop: true,
            autoplay: false,
            slidesPerView: 1,
        });

    }

    let latestNewsSwipersMobile = document.getElementsByClassName('latestnewslider-swiper-mobile');

    for (let i = 0; i < latestNewsSwipersMobile.length; i++) {

        let swiperElementMobile = latestNewsSwipersMobile[i];

        let swiperMobileID = '#' + swiperElementMobile.id;

        const swiperMobile = new Swiper(swiperMobileID, {
            pagination: {
                el: swiperMobileID + "-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: swiperMobileID + "-next",
                prevEl: swiperMobileID + "-prev",
            },
            direction: 'vertical',
            loop: true,
            autoplay: false,
            slidesPerView: 1,
        });

    }
});
